import React from 'react';
import Intent from './intent.jsx';


class IntentsSelector extends React.Component {

  handleSelection = (intent) => {
    const newSelection = [];
    this.props.selectedIntents.map(function (oldValue) {
      if (oldValue !== intent) {
        newSelection.push(oldValue);
      }
    });

    if (newSelection.length === this.props.selectedIntents.length) {
      newSelection.push(intent);
    }

    this.props.onSelectionChanged(newSelection);
  }

  _arrayToObjectMap(inputArray) {
    const object = {};
    inputArray.map(function (key) {
      object[key] = true;
    });

    return object;
  }

  render() {
    const that = this;
    const selectedIntents = this._arrayToObjectMap(that.props.selectedIntents);
    const intents = Object.keys(this.props.intents).map(function (tag) {
      let intent = that.props.intents[tag];
      let selected = selectedIntents[tag];
      return <div key={tag}><Intent tag={intent.tag} name={intent.name} image={intent.imageUrl}
                                    handleSelection={that.handleSelection}
                                    isSelected={selected}/></div>;

    });
    return (
      <div className='infa-intents-selector'>
        <div className='infa-intents-selector-name'><span>{this.props.name}</span></div>
        <div className='infa-intents-selector-intent-container'>
          <div className='infa-intents-selector-intent-container-grid'>
            {intents}
          </div>

        </div>

      </div>
    );

  }
}

export default IntentsSelector;


